import React from 'react'
import PropTypes from 'prop-types'
import { ListItemIcon } from '@material-ui/core'
import { COLORS } from 'Constants/Theme'

const transactionImage = '/assets/transactionMatching.svg'
const TransactionIcon = ({ style, className, width = 20, height = 20 }) => (
  <ListItemIcon style={{ color: COLORS.WHITE }}>
    <img
      src={transactionImage}
      alt="Transaction Matching"
      width={width}
      height={height}
      style={style}
    />
  </ListItemIcon>
)

TransactionIcon.propTypes = {
  style: PropTypes.object,
  width: PropTypes.number,
  height: PropTypes.number,
}

export default TransactionIcon
